import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { spacing, display } from '@mui/system';
import { useLocation } from 'react-router';
import { useMemo } from 'react';
import { LeftNav } from './leftNav/LeftNav.component';

const StyledMain = styled.main`
  background-color: ${({ theme }) => theme.palette.grey[0]};
  display: flex;
  flex-grow: 1;
  min-width: 0;
  position: relative;
  overflow: auto;
  scroll-behavior: smooth;
  width: 100%;
  ${spacing}
  ${display}
`;

export const PageLayoutShell = ({
  children,
  topNavHidden = false,
  ...props
}) => {
  const { pathname } = useLocation();
  const isLeftNavPage = useMemo(() => (![
    '/webcast/home',
    '/webcast/speakerlibrary',
    '/webcast/webcasts',
    '/webcast/login',
    '/webcast/logout',
    '/webcast/resetpassword',
    '/webcast/manageusers',
    '/webcast/accountdashboard',
    '/webcast/profilesettings',
  ].includes(pathname)), [pathname]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'row',
      height: !topNavHidden ? 'calc(100vh - 53px)' : '100%',
      width: '100%',
    }}
    >
      {isLeftNavPage && <LeftNav />}
      <StyledMain
        id="startOfContent"
        {...props}
      >
        {children}
      </StyledMain>
    </div>
  );
};

PageLayoutShell.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  startOfContentLabel: PropTypes.string,
  disableStartOfContentLink: PropTypes.bool,
  topNavHidden: PropTypes.bool,
};
